// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5087 ? "ec45d31a" : chunkId) + "." + {"5087":"eb98be2b0e324a45","6919":"f0dfd1a5f11a4d66","9985":"b22eb6cc6626bb72"}[chunkId] + ".js";
};